<script>
  import { HStack, VStack, Spacer } from "../component/layout";
  import { Button } from "../component/widget";
  import { Background, Padding, Frame, Border } from "../component/modifier";

  export let name;
  export let thumbnail = "logo_small";
  export let action;
</script>

<div>
  <Button {action}>
    <Frame width="200" height="240">
      <VStack alignment="center">
        <Frame width="180">
          <Border
            color="var(--primary-light-color)"
            hover="var(--secondary-light-color)"
            width="5"
            radius="50%">
            <Background color="white">
              <HStack>
                <Spacer />
                <VStack>
                  <Spacer />
                  <Padding>
                    <slot name="thumbnail">
                      <img src="/images/{thumbnail}.png" alt="logo" width="128" height="128" />
                    </slot>
                  </Padding>
                  <Spacer />
                </VStack>
                <Spacer />
              </HStack>
            </Background>
          </Border>
        </Frame>
        <Padding>
          <span class="name">{name}</span>
        </Padding>
      </VStack>
    </Frame>
  </Button>
</div>

<style>
  div {
    color: white;
    white-space: nowrap;
    text-align-last: center;
  }
  div:hover {
    font-size: 1.1em;
    color: var(--secondary-light-color);
    cursor: pointer;
  }
</style>
